(function () {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  if (params.token !== null) {
    let value = params.token;
    localStorage.setItem("SSOToken", value);
  }
  const atriumParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  if (atriumParams.skey !== null) {
    let value = atriumParams.skey;
    localStorage.setItem("SSOAtriumToken", value);
  }
})();
